import { forwardRef } from 'react';

import { CardInstitutionalProps } from '@/app/(main)/(pages)/(institucional)/_types/card-institutional.types';
import { Link } from '@/components/ui/link/link.component';
import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Card } from '@/components/ui/card.component';

export const CardInstitutional = forwardRef<HTMLDivElement, CardInstitutionalProps>(
  ({ titleIcon, title, description, buttons = [], dataTestID }, ref) => {
    return (
      <Card className="w-full lg:w-1/2 h-full flex flex-col flex-1 p-5" ref={ref} data-testid={dataTestID}>
        <div className="mb-2 flex items-start">
          {titleIcon && <Icon icon={titleIcon} size="xl" className="text-gray-500" />}
          <span className="text-xl text-gray-800 font-semibold ml-2">{title}</span>
        </div>
        <div className="text-gray-700 mb-4">
          <span>{description}</span>
        </div>
        <div className="mt-auto">
          {buttons.map((button, idx) => (
            <Button
              key={idx}
              variant={button.variant || 'default'}
              startIcon={button.icon}
              startIconSize="lg"
              onClick={button.action === 'function' ? button.onClick : undefined}
              className={idx > 0 ? 'mt-4' : ''}
              asChild={button.action === 'link'}
              data-testid={button.dataTestID}
              data-analytics-event={button.action != 'link' ? button['data-analytics-event'] : undefined}
            >
              {button.action === 'link'
                ? (
                    <Link prefetch={false} href={button.link || '#'} rel={button.rel} target={button.target} className="leading-6" data-analytics-event={button['data-analytics-event']}>
                      {button.text}
                    </Link>
                  )
                : (
                    button.text
                  )}
            </Button>
          ))}
        </div>
      </Card>
    );
  },
);

CardInstitutional.displayName = 'CardInstitutional';
